/*
   Show and manage bootstrap alert
   The component will check if there is headline or message and will try to
   translate them, else will return a default message.

   Requirement:
     1.rootStore as props with:
        1.1 observable   showAlert   boolean value
        1.2 alert    object with the following attributes: {type: "info", timeout: 500, headline: "", message: "", intlValues: { name: "John"}};

   Optional:
     headline and/or message can be used to add more information to the alert.
     A proper translation must be provided or a default message.

 */

import React from 'react';
import PropTypes from 'prop-types';
import {action} from 'mobx';
import {observer} from 'mobx-react'
import {injectIntl} from 'react-intl';


import {Alert, AlertContainer} from 'react-bs-notifier'

@observer
class BsAlert extends React.Component {
    constructor(props) {
        super(props);


        this.state = {};
    }

    render() {
        const {rootStore} = this.props;

        return (
            <div>
                <AlertContainer position="top-right">
                    {rootStore.alerts.map((alert, index) => this.renderAlert(alert, index))}
                </AlertContainer>
            </div>
        );
    }

    @action
    handleDismiss = (alert) => {
        const {rootStore} = this.props;

        rootStore.alerts.remove(alert);
    };


    renderAlert = (alert, index) => {
        const {intl} = this.props;

        const headline = alert.headline.trim() ?
            intl.formatMessage({
                id: alert.headline,
                defaultMessage: alert.headline
            }, alert.intlValues) : "";

        const message = alert.message.trim() ?
            intl.formatMessage({
                id: alert.message,
                defaultMessage: alert.message
            }, alert.intlValues) : "";


        return (
            <Alert key={index}
                   type={alert.type}
                   headline={headline}
                   timeout={alert.timeout}
                   onDismiss={this.handleDismiss.bind(null, alert)}
            >
                {message}
            </Alert>
        )

    };
}


BsAlert.propTypes = {
    rootStore: PropTypes.object.isRequired,
};


export default injectIntl(BsAlert);